<div class="u-shadow-mini" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					>
						<img class="downloadIcon" src="../../../../../assets/images/Download_Icon.svg" />
					</a>
				</span>
			</div>
		</div>
		<div [ngClass]="sectionclass != '' ? sectionclass : 'analytics-portlet-content'">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container">
					<div class="donut-legend-div" *ngIf="hasData">
						<div
							*ngFor="let legendItem of legendData; let i = index"
							class="legend-div"
							[ngClass]="currentLegend != legendItem ? 'legend-inactive' : ''"
							(click)="updateLegendData(legendItem)"
						>
							{{ legendItem }}
						</div>
					</div>
					<div class="outer-div" *ngIf="hasData">
						<div
							class="inner-div"
							[ngClass]="donutOptions.biggerDonut ? 'bigger-donut' : ''"
							*ngFor="let donut of currentChartData"
						>
							<app-solidgauge-donut [chartData]="donut.series" [donutOptions]="donutOptions"></app-solidgauge-donut>
							<div class="donut-value" [ngClass]="donutOptions.biggerDonut ? 'bigger-donut-value' : ''">
								{{ donut.value }}
							</div>
							<div class="donut-title" *ngIf="!donutOptions?.biggerDonut">{{ donut.title }}</div>
						</div>
					</div>
					<div *ngIf="!hasData" class="no-data-device">
						<div class="no-data-text">No Data Available</div>
					</div>
				</div>
			</div>
		</div>
		<div [ngClass]="sectionclass != '' ? sectionclass : 'device-table-widget'" *ngIf="hasData">
			<ngx-datatable
				class="datatable"
				[rows]="tableData"
				[columns]="columns"
				[sortType]="'single'"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="'auto'"
				[limit]="10"
				[reorderable]="reorderable"
			>
				<ngx-datatable-footer>
					<ng-template
						ngx-datatable-footer-template
						let-rowCount="rowCount"
						let-pageSize="pageSize"
						let-selectedCount="selectedCount"
						let-curPage="curPage"
						let-offset="offset"
					>
						<table class="footer-table">
							<tr>
								<td>Total</td>
								<td *ngIf="totalObj.impressions">{{ totalObj.impressions | number }}</td>
								<td *ngIf="totalObj.displayClicks">{{ totalObj.clicks | number }}</td>
								<td *ngIf="totalObj.ctvHouseholdVisits">{{ totalObj.householdVisits | number }}</td>
								<td *ngIf="totalObj.ctvWebsiteAttributions">{{ totalObj.websiteAttributions | number }}</td>
								<td *ngIf="totalObj.displayClickRate">{{ totalObj.clickRate | number : '0.2-2' }}%</td>
								<td *ngIf="totalObj.displayCost">{{ totalObj.cost | number }}%</td>
								<td *ngIf="totalObj.displayViewThroughs">{{ totalObj.view_throughs | number }}</td>
								<td *ngIf="totalObj.displayViewThroughRate">{{ totalObj.viewthroughrate | number : '0.2-2' }}%</td>
								<td *ngIf="totalObj.displayYoutubeImprs">{{ totalObj.youtube_verified_imprs | number }}</td>
								<td *ngIf="totalObj.displayYoutubeImprsRate">
									{{ totalObj.youtube_verified_imprs_rate | number : '0.2-2' }}%
								</td>
							</tr>
						</table>
					</ng-template>
				</ngx-datatable-footer>
			</ngx-datatable>
		</div>
	</div>
</div>
